import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { SimpleLayout } from 'src/layouts/simple';
import { AuthSplitLayout } from 'src/layouts/auth-split';
import { AuthCenteredLayout } from 'src/layouts/auth-centered';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

const LoginPage = lazy(() => import('src/pages/auth/login'));
const RegisterPage = lazy(() => import('src/pages/auth/register'));
const ResetPasswordPage = lazy(() => import('src/pages/auth/reset-password'));
const UpdatePasswordPage = lazy(() => import('src/pages/auth/update-password'));
const ConfirmInvitaionPage = lazy(() => import('src/pages/auth/confirm-invitation'));
const ConfirmEmailPage = lazy(() => import('src/pages/auth/confirm-email'));

// ----------------------------------------------------------------------

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: 'login',
        element: (
          <GuestGuard>
            <AuthSplitLayout
              section={{
                title: "Hi, Welcome Back",
                subtitle: "Sign in to continue",
                imgUrl: `${CONFIG.assetsDir}/assets/images/auth/Login.png`
              }}
            >
              <LoginPage />
            </AuthSplitLayout>
          </GuestGuard>
        ),
      },
      {
        path: 'register',
        element: (
          <GuestGuard>
            <AuthSplitLayout
              section={{
                title: "Start your journey",
                subtitle: "Sign up to get started",
                imgUrl: `${CONFIG.assetsDir}/assets/images/auth/Registration.png`
              }}
            >
              <RegisterPage />
            </AuthSplitLayout>
          </GuestGuard>
        ),
      },
      {
        path: 'reset-password',
        element: (
          <GuestGuard>
            <AuthSplitLayout
              section={{
                title: "Reset your password",
                subtitle: "Enter your email to reset your password",
                imgUrl: `${CONFIG.assetsDir}/assets/images/auth/Login.png`
              }}
            >
              <ResetPasswordPage />
            </AuthSplitLayout>
          </GuestGuard>
        ),
      },
      {
        path: 'update-password/:id',
        element: (
          <GuestGuard>
            <AuthSplitLayout
              section={{
                title: "Update your password",
                subtitle: "Enter your new password",
                imgUrl: `${CONFIG.assetsDir}/assets/images/auth/Login.png`
              }}
            >
              <UpdatePasswordPage />
            </AuthSplitLayout>
          </GuestGuard>
        ),
      },
      {
        path: 'confirm-invitation',
        element: (
          <GuestGuard>
            <SimpleLayout>
              <ConfirmInvitaionPage />
            </SimpleLayout>
          </GuestGuard>
        ),
      },
      {
        path: 'confirm-email/:id',
        element: (
          <GuestGuard>
            <AuthCenteredLayout>
              <ConfirmEmailPage />
            </AuthCenteredLayout>
          </GuestGuard>
        ),
      },
    ],
  },
];
